<script setup lang="ts">
import type { FlatStatus } from '~/types/types'

const props = defineProps<{
  status: FlatStatus
}>()

const getClass = () => {
  if (props.status === 'Dostępne' || props.status === 'Na wynajem') {
    return 'text-white bg-Secondary'
  } else if (props.status == 'Sprzedane') {
    return 'text-Tekst bg-Sprzedane'
  } else if (props.status == 'Rezerwacja') {
    return 'text-Tekst bg-Rezerwacja'
  } else if (props.status == 'Rezerwacja-ustna') {
    return 'text-Tekst bg-Rezerwacja'
  } else {
    return 'text-Tekst'
  }
}
</script>

<template>
  <div
    class="rounded-full flex items-center py-2.5 px-8 w-fit"
    :class="getClass()"
  >
    <span class="text-Paragraph">{{ props.status || '-' }}</span>
  </div>
</template>
